// App config for API and domain

export const ROOT_DOMAIN = 'qrhub.barneyparker.com';

// Use this for all API calls
export const API_BASE_URL = `https://${ROOT_DOMAIN}/qr`;
